export enum SchemaType {
  DatasetType = 'DatasetType',
  EntityType = 'EntityType',
  WorkHistoryType = 'WorkHistoryType',
  TrainingType = 'TrainingType',
  GraduateType = 'GraduateType',
  InsuranceCoverageType = 'InsuranceCoverageType',
  State = 'State',
  ProviderStatus = 'ProviderStatus',
  PermissionLevel = 'PermissionLevel',
  ProviderInfoType = 'ProviderInfoType',
  MonitoringInterval = 'MonitoringInterval',
  CredentialingRequestType = 'CredentialingRequestType',
  BoardCertificationType = 'BoardCertificationType',
  Gender = 'Gender',
  Ethnicity = 'Ethnicity',
  FacilityInfoType = 'FacilityInfoType',
  SourceIssue = 'SourceIssue'
}

export const DefaultHealthCheckValue = SchemaType.EntityType;
